module.exports = __webpack_public_path__ + "img/fi-rr-time-delete.39b07ebe.svg";